import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'

import Tag from '~/components/Abstracts/Tag'

import { CTA } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface MaxCountTagProps {
  className?: string
  maxLength?: number
  currentText?: string
}

function MaxCountTag({ className, maxLength, currentText }: MaxCountTagProps) {
  const t = useTranslate()
  const remainingCharacters = maxLength - currentText?.length
  return (
    <Tag className={cx(css.MaxCountTag, className)}>
      {`${
        typeof remainingCharacters === 'number' && !isNaN(remainingCharacters)
          ? remainingCharacters
          : maxLength
      } ${t(CTA.CHARACTERS_LEFT)}`}
    </Tag>
  )
}

MaxCountTag.defaultProps = {}

export default MaxCountTag
